import { render, staticRenderFns } from "./Ikas.vue?vue&type=template&id=68d952c0&scoped=true"
import script from "./Ikas.vue?vue&type=script&lang=js"
export * from "./Ikas.vue?vue&type=script&lang=js"
import style0 from "./Ikas.vue?vue&type=style&index=0&id=68d952c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d952c0",
  null
  
)

export default component.exports